import { connect } from 'react-redux';
import {
  importRoster,
  importRoute,
  newGroup,
  removeGroup,
  dispatchRemoveMemberFromGroup,
  editGroup,
  addMember,
  editMember,
 } from '../modules/tour';

import TourRosterTab from './TourRosterTab';

const mapDispatchToProps = {
  dispatchRemoveMemberFromGroup,
  importRoster,
  importRoute,
  newGroup,
  removeGroup,
  editGroup,
  addMember,
  editMember,
};

const mapStateToProps = state => ({
  tour: state.tours.selectedTour.tour,
});
const TourRosterTabContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(TourRosterTab);
export default TourRosterTabContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRosterTabContainer.js